// Clés de droits BeOne utilisées par le POC. La liste complète est dans COMMON.AUTH_RIGHT ; on n'ajoute ici que celles
// qu'on applique, avec l'endroit où le BeOne historique les vérifie, pour garder le même comportement.
export const RIGHTS = {
  planning: {
    calendar: 'da.planning.calendar', // apps/common/templates/_primary_menu.php:257
    createOperation: 'da.planning.create_operation', // selectChannel/actions:21
    defineRecurring: 'da.planning.create_operation.define_recurring', // planning/templates/_menubar.php:63
    advancedSearch: 'da.planning.advanced_search', // _primary_menu.php:286
  },
  library: {
    operation: 'da.library.operation', // _primary_menu.php:298 (Bibliothèque, fusionnée dans la recherche avancée)
    draft: 'da.library.draft', // drafts/actions:24
    offerRecurrence: 'da.library.offer_recurrence', // offerRecurrence/actions:21
    journey: 'da.library.journey', // journey/actions:21
    timeslots: 'da.library.timeslotsOperations', // timeslotsOperations/actions:22
    offers: 'da.library.offers', // _primary_menu.php:1135 (Acoustic)
  },
  preconization: 'da.preconization', // _primary_menu.php:280
  operation: {
    createTest: 'da.operation.create_test', // planning/validation/templates/indexSuccess.php:151
  },
  quotation: 'da.quotation', // planning/validation/actions:150 (devis)
  parameter: {
    forceOfferNumber: 'da.parameter.force_offer_number', // planning/parameter/templates/_params_offer.php:52
  },
  cashdesk: {
    preEdit: 'da.cashdesk.preEdit', // cashdesk/parameter/actions:808 (offre pré-éditée)
  },
  powerbi: {
    show: 'da.powerbi.show', // _primary_menu.php:345
    showInternal: 'da.powerbi.show.internal',
    reportPrefix: 'da.powerbi.report_', // + clé du rapport (_primary_menu.php:502)
  },
  sms: {
    multipleBat: 'da.sms.bat_multiples', // library/dashBoard/actions:1235
  },
  customer: {
    search: 'da.customer.search', // customers/search/actions:22
    create: 'da.customer.create', // customers/creation/actions:19
    cardList: 'da.customer.cardlist',
    personIdList: 'da.customer.person_id_list',
    emailList: 'da.customer.email_list',
    phoneList: 'da.customer.phone_list',
    walletList: 'da.customer.wallet_list',
    changeStore: 'da.customer.change_store', // dashBoard/templates/_personDescription.php:63
    changeAccount: 'da.customer.operation.change_account', // marketing/templates/indexSuccess.php:116
    addManualTransaction: 'da.customer.transaction.add_manual_transaction', // transaction/templates/indexSuccess.php:161
    addManualTransactionPage: 'da.customer.transaction.add_manual_trans.not_yet', // transaction/actions:907
    changeDetail: 'da.customer.change_detail', // dashBoard/actions:228 (onglet Détails)
    changeForm: 'da.customer.change_form', // dashBoard/actions:225 (questionnaire)
    histo: 'da.customer.histo', // _personDescription.php:321
    customerService: 'da.customer_service', // mode service client : donne aussi l'historique et le NPAI
  },
  query: {
    extract: 'da.query.extract', // query/query/actions:22
    noExtract: 'da.query.no_extract', // restriction : retire « Extraire la sélection » (ActionFormQueryForm:29)
  },
  admin: {
    batchs: 'da.admin.batchs', // apps/batch/modules/*/actions
  },
  store: {
    create: 'da.store.create',
    show: 'da.store.show',
    modify: 'da.store.modify',
    companyShow: 'da.store_company.show', // les droits store_company.* valent leurs équivalents store.*
    companyModify: 'da.store_company.modify',
    batchChange: 'da.store.batch_change', // _primary_menu.php:1079
    contacts: 'da.store.contacts_magasins', // store/templates/_showModifStore.php:64
    url: 'da.store.url', // store/templates/_showModifStore.php:112
  },
} as const;

// Canaux de campagne du POC → clé de droit du canal BeOne (lib/model/doctrine/CHANNELTable.class.php:59-69).
// La création sur un canal demande aussi 'da.planning.create_operation.<canal BeOne>'.
export const CHANNEL_RIGHT_NAME = {
  courrier: 'mailing',
  email: 'emailing',
  sms: 'sms',
  wallet: 'wallet',
  cashdesk: 'cashdesk',
} as const;
